var STREAM_TYPE_BUFFER = 'Buffer';
var STREAM_TYPE_BASE64 = 'Base64';
function normalizeStream(stream) {
  if (!stream) {
    return;
  }
  if (stream.type === STREAM_TYPE_BUFFER && Array.isArray(stream.data)) {
    return typeof Buffer === 'function' ? Buffer.from(stream.data) : new Uint8Array(stream.data).buffer;
  }
  if (stream.type === STREAM_TYPE_BASE64 && typeof stream.data === 'string') {
    return Buffer.from(stream.data, 'base64');
  }
  return stream;
}
function toStream(data) {
  return {
    type: STREAM_TYPE_BASE64,
    data: data.toString('base64')
  };
}
function streamToSafeString(stream) {
  var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf-8';
  try {
    if (Buffer.isBuffer(stream)) {
      return stream.toString(encoding);
    } else if (stream instanceof ArrayBuffer) {
      var decoder = new TextDecoder(encoding);
      return decoder.decode(new Uint8Array(stream));
    }
  } catch (error) {
    return '';
  }
  return '';
}
export { normalizeStream, streamToSafeString, toStream };
